"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var clsx_1 = require("clsx");
var core_1 = require("@material-ui/core");
var discountLabelStyles_1 = require("./discountLabelStyles");
var DiscountLabelTitle = function (_a) {
    var _b;
    var label = _a.label, boldLabel = _a.boldLabel, labelClassNames = _a.labelClassNames;
    var styles = discountLabelStyles_1.default();
    return (<core_1.Grid item={true} sm={9} xs={6} className={clsx_1.default(labelClassNames, styles.label, [(_b = {}, _b[styles.boldLabel] = boldLabel, _b)])} data-test={'summary:car_details:discount:label'}>
      {label}
    </core_1.Grid>);
};
exports.default = DiscountLabelTitle;
